import { BORDER_WIDTH } from '../config/constants';

export { BORDER_WIDTH };
export const STRONG_BORDER_WIDTH = 2;

export function drawHairline(color) {
    return `${BORDER_WIDTH}px solid ${color}`;
}

export function drawInsetRing(color, width) {
    return `inset 0 0 0 ${width}px ${color}`;
}

export function drawStrongInsetRing(theme, color) {
    return drawInsetRing(color, theme.shape.strongBorderWidth);
}

export function drawStroke(color, width) {
    return `${width}px solid ${color}`;
}

export function drawStrongStroke(theme, color) {
    return drawStroke(color, theme.shape.strongBorderWidth);
}

export function createDisabledEdge(width) {
    return {
        outline: `${width}px dashed currentColor`,
        outlineOffset: -width,
    };
}
